import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn';

/**
 * 배지.
 *
 * 민트 배지는 한 카드에 하나까지다 — 면이 여럿 경쟁하면
 * 이 시스템의 유일한 강조 장치가 무력해진다. 나머지는 외곽선형으로 내린다.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-[9px] py-[3px] ' +
    'text-[11.5px] font-semibold tracking-[-0.01em]',
  {
    variants: {
      variant: {
        mint: 'bg-primary text-primary-foreground',
        ink: 'bg-foreground text-background',
        outline: 'border border-border text-muted-foreground font-medium',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps): ReactElement {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
